import { FC, ReactNode } from "react";
import { HamburgerIcon } from "@chakra-ui/icons";
import {
  Box,
  Drawer as ChakraDrawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  IconButton,
  useDisclosure,
} from "@chakra-ui/react";
import { Logo } from "./Logo";

interface Props {
  children: ReactNode;
}

export const MobileMenu: FC<Props> = ({ children }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box>
      <IconButton
        bg="transparent"
        color="primary"
        aria-label="Open menu"
        icon={<HamburgerIcon boxSize="7" />}
        onClick={onOpen}
      />
      <ChakraDrawer onClose={onClose} isOpen={isOpen} size="full">
        <DrawerOverlay />
        <DrawerContent bg="transparent">
          <DrawerHeader>
            <Logo />
          </DrawerHeader>
          <DrawerCloseButton fontSize="18" color="gray.700" />
          <DrawerBody>{children}</DrawerBody>
        </DrawerContent>
      </ChakraDrawer>
    </Box>
  );
};
